module.exports = __webpack_public_path__ + "img/40_50.0e2aab51.png";